import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Auth
export const changePassword = (newPassword) => axios.post(`${API}/auth/change-password`, { new_password: newPassword });


// Clients
export const getClients = () => axios.get(`${API}/clients`);
export const createClient = (data) => axios.post(`${API}/clients`, data);
export const deleteClient = (id) => axios.delete(`${API}/clients/${id}`);
export const updateClient = (id, data) => axios.put(`${API}/clients/${id}`, data);
export const reassignClient = (id, assignedTo) => axios.put(`${API}/clients/${id}/assign`, { assigned_to: assignedTo });
export const getAllClients = () => axios.get(`${API}/superadmin/all-clients`);


// Alerts
export const getAlerts = () => axios.get(`${API}/alerts`);
export const createAlert = (data) => axios.post(`${API}/alerts`, data);
export const updateAlert = (id, data) => axios.patch(`${API}/alerts/${id}`, data);
export const deleteAlert = (id) => axios.delete(`${API}/alerts/${id}`);

// Market Prices
export const getMarketPrices = (energyType) => 
  axios.get(`${API}/market-prices`, { params: { energy_type: energyType } });
export const getLatestPrices = () => axios.get(`${API}/market-prices/latest`);
export const getPriceHistory = (contractName, days = 30) => 
  axios.get(`${API}/market-prices/history/${encodeURIComponent(contractName)}`, { params: { days } });

// Market Analysis
export const getLatestAnalysis = () => axios.get(`${API}/market-analysis/latest`);

// Dashboard
export const getDashboardStats = () => axios.get(`${API}/dashboard/stats`);

// PDF Upload
export const uploadPDF = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/upload-pdf`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Callback Requests
export const getCallbackRequests = () => axios.get(`${API}/callback-requests`);
export const createCallbackRequest = (data) => axios.post(`${API}/callback-requests`, data);
export const updateCallbackRequest = (id, status) => 
  axios.patch(`${API}/callback-requests/${id}`, null, { params: { status } });

// Triggered Alerts
export const getTriggeredAlerts = () => axios.get(`${API}/triggered-alerts`);

// Pending Alerts (to send)
export const getPendingAlerts = () => axios.get(`${API}/pending-alerts`);
export const sendAlert = (logId, customTexts) => {
  if (customTexts) {
    return axios.post(`${API}/pending-alerts/send/${logId}`, { custom_texts: customTexts });
  }
  return axios.post(`${API}/pending-alerts/send/${logId}`);
};
export const sendAllAlerts = () => axios.post(`${API}/pending-alerts/send-all`);
export const dismissAlert = (logId) => axios.post(`${API}/pending-alerts/dismiss/${logId}`);

// Email Preview & Templates
export const getEmailPreview = (logId) => axios.get(`${API}/email-preview/${logId}`);
export const getEmailTemplates = () => axios.get(`${API}/email-templates`);
export const saveEmailTemplate = (data) => axios.post(`${API}/email-templates`, data);
export const updateEmailTemplate = (id, data) => axios.put(`${API}/email-templates/${id}`, data);
export const deleteEmailTemplate = (id) => axios.delete(`${API}/email-templates/${id}`);

// Check Alerts Manually
export const checkAlerts = () => axios.post(`${API}/check-alerts`);

// Weekly Summary
export const sendWeeklySummary = () => axios.post(`${API}/send-weekly-summary`);

// Recommendations
export const getRecommendations = () => axios.get(`${API}/recommendations`);

// Available Contracts
export const getAvailableContracts = () => axios.get(`${API}/available-contracts`);

// Reports
export const downloadClientReport = (clientId) => axios.get(`${API}/reports/client/${clientId}`, { responseType: 'blob' });
export const downloadMarketReport = () => axios.get(`${API}/reports/market`, { responseType: 'blob' });

// Seed Data
export const seedDemoData = () => axios.post(`${API}/seed-demo-data`);

// Agencies
export const getAgencies = () => axios.get(`${API}/agencies`);
export const seedAgencies = () => axios.post(`${API}/agencies/seed`);
export const getMyAgencies = () => axios.get(`${API}/my-agencies`);
export const createMyAgency = (data) => axios.post(`${API}/my-agencies`, data);
export const updateMyAgency = (id, data) => axios.put(`${API}/my-agencies/${id}`, data);
export const deleteMyAgency = (id) => axios.delete(`${API}/my-agencies/${id}`);
export const setDefaultAgency = (id) => axios.put(`${API}/my-agencies/${id}/set-default`);
export const updateUserAgency = (agencyId) => axios.put(`${API}/users/me/agency`, { agency_id: agencyId });

// Super Admin
export const getSuperAdminStats = () => axios.get(`${API}/superadmin/stats`);
export const getFranchises = () => axios.get(`${API}/superadmin/franchises`);
export const getFranchiseClients = (id) => axios.get(`${API}/superadmin/franchises/${id}/clients`);
export const createFranchise = (data) => axios.post(`${API}/superadmin/franchises`, data);
export const updateFranchise = (id, data) => axios.put(`${API}/superadmin/franchises/${id}`, data);
export const deleteFranchise = (id) => axios.delete(`${API}/superadmin/franchises/${id}`);
export const resendFranchiseCredentials = (id) => axios.post(`${API}/superadmin/franchises/${id}/resend-credentials`);
export const resendFranchiseCredentialsBulk = (onlyPending = true) => axios.post(`${API}/superadmin/franchises/resend-credentials-bulk?only_pending=${onlyPending}`);
export const lookupUserByEmail = (email) => axios.get(`${API}/superadmin/users/lookup?email=${encodeURIComponent(email)}`);
export const deleteUserByEmail = (email) => axios.delete(`${API}/superadmin/users/by-email?email=${encodeURIComponent(email)}`);
export const exportBillingCSV = () => axios.get(`${API}/superadmin/billing/export`, { responseType: 'blob' });

// Team Management (Franchise)
export const getTeamMembers = () => axios.get(`${API}/team`);
export const createTeamMember = (data) => axios.post(`${API}/team`, data);
export const updateTeamMember = (id, data) => axios.put(`${API}/team/${id}`, data);
export const deleteTeamMember = (id) => axios.delete(`${API}/team/${id}`);
export const uploadTeamPhoto = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/team/${id}/photo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
